export default "__VITE_ASSET__x_cD_ZWO__"